// src/components/modals/app-modals/CAPEVrProtocolModal.jsx

import BaseModalApp from './BaseModalApp';
import AVIcon from '../../icons/AllVoicedIcons';
import CAPEVrProtocol from '../../../activities/cape-vr/cape-vr-views/CAPEVRProtocol';
import { useTranslation } from 'react-i18next';

const CAPEVrProtocolModal = ({ isOpen, onRequestClose }) => {
  const { t } = useTranslation();

  return (
    <BaseModalApp
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel="CAPE-V Protocol"
      className="ReactModal__Content modal--app modal--750px"
      overlayClassName="ReactModal__Overlay modal-overlay--app"
    >
      <div className="modal-header">
        <h2>{t('cape_vr_protocol')}</h2>
        <button
          type="button"
          className="modal-close-button"
          onClick={onRequestClose}
        >
          <AVIcon icon="close" size={18} aria-hidden="true" />
        </button>
      </div>

      <div className="modal-content-scroll">
        <CAPEVrProtocol />
      </div>
    </BaseModalApp>
  );
};

export default CAPEVrProtocolModal;
